import { render } from "./WidePageTemplate.vue?vue&type=template&id=6937cc65&scoped=true&ts=true"
import script from "./WidePageTemplate.vue?vue&type=script&lang=ts"
export * from "./WidePageTemplate.vue?vue&type=script&lang=ts"

import "./WidePageTemplate.vue?vue&type=style&index=0&id=6937cc65&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6937cc65"]])

export default __exports__